import { OperationsComponent } from "./component";

export const OperationsContainer = () => {
  return <OperationsComponent />;
};
